import { Col, Row } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export const RoleTooltip = () => {
  return (
    <Col span={16} offset={8}>
      <Row className="w-100 align-start mt-4">
        <Col span={3}>
          <InfoCircleOutlined className="text-md title" />
        </Col>
        <Col span={21}>
          <p className="my-0 text-sm title w-500">
            With the role change the user will be automatically logged out.
            Please make sure that they have saved all current work.
          </p>
        </Col>
      </Row>
    </Col>
  );
};
